module.exports = __webpack_public_path__ + "img/昆明保利南亚之窗.e170f374.png";